import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AveriasService } from 'src/app/servicios/averias.service';
import { PerfilesUsuarioService } from 'src/app/servicios/perfiles-usuario.service';
import { SnackBarComponent } from '../../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { convertToBoolProperty } from '@nebular/theme/components/helpers';
import { AnalyticsService } from '../../servicios/analytics.service';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { ChangePasswordComponent } from 'src/app/gestion-usuarios/change-password/change-password.component';
import { NuevoUsuarioOperadorComponent } from 'src/app/gestion-usuarios/nuevo-usuario-operador/nuevo-usuario-operador.component';
import { EditUsuarioComponent } from 'src/app/gestion-usuarios/edit-usuario/edit-usuario.component';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { DatePipe } from '@angular/common';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver'; 

@Component({
    selector: 'app-sub-usuarios-operador',
    templateUrl: './sub-usuarios-operador.component.html',
    styleUrls: ['./sub-usuarios-operador.component.css'],
    standalone: true,
    imports: [EditUsuarioComponent, NuevoUsuarioOperadorComponent,ChangePasswordComponent,
       FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule,
        DropdownModule, MatCardModule, MatFormFieldModule, MatInputModule, 
        AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule,
         NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule,
        AgGridAngular],
    providers: [DatePipe],
})
export class SubUsuariosOperadorComponent implements OnInit {

  @ViewChild('editUsuario') private templateRefEditUsuario: TemplateRef<any>;
  @ViewChild('newUsuarioOperador') private templateRefNewUsuarioOperador: TemplateRef<any>;
  @ViewChild('MSJConfirmaCancelarDLT') private templateRefDltUsuario: TemplateRef<any>;
  @ViewChild('changePassword') private templateRefChangePassword: TemplateRef<any>;
  idCliente: number;
  columnDefinitionsUsuarios: ColDef[];//Column[];
  gridOptionsUsuarios: GridOption;
  dataView: any;
  gridObj: any;
  angularGrid: AngularGridInstance;
  datasetUsuarios;
  showGrilla = false;
  showSpinner = false;
  showSpinnerEliminar: boolean = false;
  modalRef: BsModalRef;
  durationInSeconds = 3;
  deshabilitarExportUser = true;

  empresaSelected;
  perfilSelected;
  empresas = []
  perfiles = [];
  flagActivo = '1';
  optAct = [
    { value: '1', label: 'Activo' },
    { value: '0', label: 'No Activo' },
  ];
  dataParaEdit;
  usuarioAEliminar;
  userToChangePass;
  idOperador: number = 0;
  idTipoOperador: number = 0;

  
  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;

  constructor(private servicioUsuarios: PerfilesUsuarioService, private dateFormatter: DatePipe,
    private modalService: BsModalService, private svcAverias: AveriasService,
    private _snackBar: MatSnackBar, private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem("idCliente"));
    this.idOperador = Number(localStorage.getItem("idOperador"));
    this.idTipoOperador = Number(localStorage.getItem("idTipoOperador"));
    this.formatoGrilla();
    this.llenarEmpresas()
    this.llenarPerfiles();
    this.svcAnalytics.setAnalyticsPageView();
  }

  llenarEmpresas() {
    if (this.servicioUsuarios.GESTIONAR_USUARIOS) {
      this.svcAverias.getOperadoresPorCliente(this.idCliente).subscribe(data => {
        let misEmpresas;
        this.empresas = [{ value: 0, label: "Ninguna" }];
        misEmpresas = data;
        misEmpresas.forEach(e => {
          this.empresas.push({
            value: e.id,
            label: e.descripcion
          })
        });
      });
    } else {
      this.svcAverias.getOperadoresPorId(this.idOperador).subscribe(data => {
        let misEmpresas;
        this.empresas = [{ value: 0, label: "Ninguna" }];
        misEmpresas = data;
        this.empresas.push({
          value: misEmpresas.id,
          label: misEmpresas.descripcion
        })
      });
    }
  }

  llenarPerfiles() {
    this.servicioUsuarios.getPerfiles().subscribe(data => {
      let misPerfiles;
      this.perfiles = [{ value: 0, label: "Ninguno" }];
      misPerfiles = data;
      let isAdmin = misPerfiles.content.find(e => e.idTipoOperador === this.idTipoOperador && e.perfilRoles.find(e => e.rol.id === 6))
      misPerfiles.content.forEach(e => {
        if (e.operador) {
          //AGREGAMOS UNA LOGICA PARA PUSHEAR LOS PERFILES DEL TIPO DE OPERADOR SI TIENE
          if (e.idTipoOperador == null || e.idTipoOperador == this.idTipoOperador && e.id !== isAdmin.id) {
            this.perfiles.push({
              value: e.id,
              label: e.descripcion
            })
          }
        }
      });
    });
  }


     // Funciones auxiliares para construir columnas
    getBaseActionColumns(): any[] {
      return [
           {
              headerName: 'Editar',         // No texto en el encabezado
              field: 'action',
              cellRenderer: params => {
                return `<i class="fa fa-edit" style="font-size: 16px; cursor: pointer;"></i>`; // Puedes personalizar más si lo deseas
              },
              width: 75,
              minWidth: 75,
              maxWidth: 75,
              //suppressExport: true,  // Equivalente a excludeFromExport
              onCellClicked: params => {
                this.openPopUpEdit(params.data);  // Llama a tu método pasando la fila
              }
            },
            {
              headerName: 'Borrar',         // No texto en el encabezado
              field: 'action',
              cellRenderer: params => {
                return `<i class="fa fa-trash" style="font-size: 16px;cursor: pointer;"></i>`; // Puedes personalizar más si lo deseas
              },
              width: 75,
              minWidth: 75,
              maxWidth: 75,
              //suppressExport: true,  // Equivalente a excludeFromExport
              onCellClicked: params => {
                this.openPopUpAgreeDisagreeDlt(this.templateRefDltUsuario, params.data);
                //this.openPopupEliminarAveria(params.data);  // Llama a tu método pasando la fila
              }
            },
                        {
              headerName: 'Reset pass',         // No texto en el encabezado
              field: 'action',
              cellRenderer: params => {
                return `<i class="fa fa-undo" style="font-size: 16px; cursor: pointer;"></i>`; // Puedes personalizar más si lo deseas
              },
              width: 75,
              minWidth: 75,
              maxWidth: 75,
              //suppressExport: true,  // Equivalente a excludeFromExport
              onCellClicked: params => {
                 this.openPopUpChangePassword(this.templateRefChangePassword, params.data);
               
              }
            },
      ];
    }


  formatoGrilla() {

    const myCustomEditFormatter: Formatter = (row: number, cell: number, value: any, columnDef: Column, dataContext: any, grid?: any) =>
      '<i class="fa fa-edit" style="font-size: 16px; cursor: pointer;"></i>';
    const myCustomDeleteFormatter: Formatter = (row: number, cell: number, value: any, columnDef: Column, dataContext: any, grid?: any) =>
      '<i class="fa fa-times-circle" style="font-size: 16px; cursor: pointer;"></i>';
    const myCustomChangeFormatter: Formatter = (row: number, cell: number, value: any, columnDef: Column, dataContext: any, grid?: any) =>
      '<i class="fa fa-undo" style="font-size: 16px; cursor: pointer;"></i>';


    const actions = this.getBaseActionColumns();

    this.gridOptionsUsuarios = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableFiltering: true,
      rowSelectionOptions: { selectActiveRow: false }
    };

    if (this.flagActivo == '0') {
      this.columnDefinitionsUsuarios = [
        { //id: 'username', 
          headerName: 'Nombre de Usuario', field: 'username', sortable: true, filter: true, floatingFilter: true, minWidth: 50 },
        { //id: 'nombre', 
          headerName: 'Nombre', field: 'nombre', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'apellido', 
          headerName: 'Apellido', field: 'apellido', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'correoElectronico', 
          headerName: 'E-mail', field: 'correoElectronico', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'empresa', 
          headerName: 'Empresa', field: 'empresa', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'perfil', 
          headerName: 'Perfil', field: 'perfil', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
      ]
    } else {
      this.columnDefinitionsUsuarios = [
        { //id: 'username', 
          headerName: 'Nombre de Usuario', field: 'username', sortable: true, filter: true, floatingFilter: true, minWidth: 50 },
        { //id: 'nombre', 
          headerName: 'Nombre', field: 'nombre', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'apellido', 
          headerName: 'Apellido', field: 'apellido', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'correoElectronico', 
          headerName: 'E-mail', field: 'correoElectronico', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'empresa', 
          headerName: 'Empresa', field: 'empresa', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        { //id: 'perfil', 
          headerName: 'Perfil', field: 'perfil', sortable: true, filter: true, floatingFilter: true, minWidth: 60 },
        ...actions,
        // {
        //   id: 'action',
        //   name: 'Editar',
        //   field: 'action', formatter: myCustomEditFormatter, width: 50, minWidth: 50, maxWidth: 50,
        //   excludeFromExport: true,    // you typically don't want this column exported
        //   onCellClick: (e, args) => {
        //     this.openPopUpEdit(args.dataContext);
        //   },
        // },
        // {
        //   id: 'action2',
        //   name: 'Borrar',
        //   field: 'action2', formatter: myCustomDeleteFormatter, width: 50, minWidth: 50, maxWidth: 50,
        //   excludeFromExport: true,    // you typically don't want this column exported
        //   onCellClick: (e, args) => {
        //     this.openPopUpAgreeDisagreeDlt(this.templateRefDltUsuario, args.dataContext);
        //   },
        // },
        // {
        //   id: 'action3',
        //   name: 'Reset pass',
        //   field: 'action3', formatter: myCustomChangeFormatter, width: 50, minWidth: 50, maxWidth: 50,
        //   excludeFromExport: true,    // you typically don't want this column exported
        //   onCellClick: (e, args) => {
        //     this.openPopUpChangePassword(this.templateRefChangePassword, args.dataContext);
        //   },
        // },
      ];
    }

  }


  exportToExcelUsuarios() {
    // (this.angularGrid as any).excelExportService.exportToExcel({
    //   filename: 'Usuarios',
    //   format: FileType.xlsx
    // });
    this.exportToExcelUsuariosexpo();
    this.svcAnalytics.setAnalyticsExcelButton();
  }

  exportToExcelUsuariosexpo(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo) {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Usuarios': worksheet },
          SheetNames: ['Usuarios']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Usuarios_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj = angularGrid.slickGrid
  }

  consultarUsuarios() {
    this.deshabilitarExportUser = true;
    let myDTO = {
      idPerfilUsuario: parseInt(this.perfilSelected) == 0 ? null : parseInt(this.perfilSelected),
      idCliente: this.idCliente,
      eliminado: this.flagActivo == '1' ? false : true,
      idOperador: this.idOperador
    }
    this.showSpinner = true;
    this.servicioUsuarios.getUsuariosOperador(myDTO).subscribe(data => {
      var operadores = data.body.filter(n => n.operador.id != null)
      if (data["status"] == 403)
        alert("El usuario no tiene permisos.")
      else if (data["status"] != 200)
        alert("Ocurrio un error al traer los datos.")
      else
        this.prepararDatos(operadores)
    }, erros => {
      this.showSpinner = false;
    })
    this.formatoGrilla();
    //gtag busqueda
    this.svcAnalytics.setAnalyticsSearchButton();
  }

  prepararDatos(array) {
    this.datasetUsuarios = [];
    console.log(array)
    let filterArray = array.filter(e => {
      console.log(!e.perfil.descripcion.includes('Admin'))
      return e.username !== localStorage.getItem("username") && !e.perfil.descripcion.includes('Admin')
    })
    console.log(filterArray)
    if (filterArray != undefined) {
      filterArray.forEach(e => {
        this.datasetUsuarios.push(
          {
            id: e.id,
            username: e.username,
            nombre: e.nombre,
            apellido: e.apellido,
            correoElectronico: e.correoElectronico,
            perfil: e.perfil.descripcion,
            perfilId: e.perfil.id,
            empresa: e.operador != null ? e.operador.descripcion : "",
            empresaId: e.operador != null ? e.operador.id : "",
            fechaAlta: e.fechaAlta,
            activo: e.activo == true ? "SI" : "NO",
            cliente: e.clientes.length > 0 ? e.clientes[0].descripcion : "",
            clienteId: e.clientes.length > 0 ? e.clientes[0].id : "",
            operador: e.operador != null ? e.operador.descripcion : "",
            operadorId: e.operador != null ? e.operador.id : "",
          }
        )
      });
      this.showGrilla = true;
      this.showSpinner = false;
      if (this.datasetUsuarios.length > 0) {
        this.deshabilitarExportUser = false;
      }
    } else {
      alert("No se encontraron registros")
      this.showSpinner = false;
    }
  }

  openPopUpEdit(data) {
    this.dataParaEdit = data;
    this.modalRef = this.modalService.show(this.templateRefEditUsuario, { class: 'modal-lg' });
  }

  dltUsuario(data) {
    this.showSpinnerEliminar = true;
    this.servicioUsuarios.deletePerfilUsuario(data.id).subscribe(data => {
      if (data["status"] == 204) {
        this.openSnackBar("Registro eliminado correctamente")
      } else {
        this.openSnackBar("Ocurrió un error")
      }
      this.hideModal("cerrar")
      this.consultarUsuarios();
      this.showSpinnerEliminar = false;
    })
  }

  openPopUpAgreeDisagreeDlt(tmpl: TemplateRef<any>, data) {
    this.usuarioAEliminar = data;
    this.modalRef = this.modalService.show(tmpl, { class: 'modal-lg' });
  }

  openPopUpChangePassword(tmpl: TemplateRef<any>, data) {
    this.userToChangePass = data;
    this.modalRef = this.modalService.show(tmpl, { class: 'modal-lg' });
  }

  crearUsuario() {
    let tmpl: TemplateRef<any>
    tmpl = this.templateRefNewUsuarioOperador
    this.modalRef = this.modalService.show(tmpl, { class: 'modal-lg' });
    //gtag alta
    this.svcAnalytics.setAnalyticsAltaButton();
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  hideModal(ev) {
    this.modalRef.hide();
  }

  hideModalUpdate(ev) {
    this.consultarUsuarios();
    this.modalRef.hide();
  }

  
  onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  

}
